import React, { useState } from 'react';
import styled from 'styled-components';
import COLORS from "utils/constants/color";

// Base button styles
const BaseButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  &.animate__animated {
    animation-duration: 0.2s !important;
  }

  /* Custom scale animations */
  &.scale-up {
    transform: scale(1.02);
  }
  
  &.scale-down {
    transform: scale(0.98);
  }
`;

// Primary Button
const PrimaryButton = styled(BaseButton)`
  background-color: ${COLORS.green};
  color: white;
`;

// Destructive Button
const DestructiveButton = styled(BaseButton)`
  background-color: #ff4d4f;
  color: white;
`;

// Outline Button
const OutlineButton = styled(BaseButton)`
  background-color: white;
  border: 1px solid #d9d9d9;
  color: #000;
  &:hover {
    border-color: #40a9ff;
    color: #40a9ff;
  }
`;

const TransparentButton = styled(BaseButton)`
  background-color: unset;
  border: none;
  outline: none;
`;

const EbookToolingButton = styled.button`
    background: linear-gradient(to right,${COLORS.indigo500}, ${COLORS.indigo600});
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 25px;
    color: white;
    z-index: 1;
    padding: 3px;
    margin-bottom:12px;
    margin-top:8px;
    margin-left:12px;
}
`;

const CustomButton = ({ variant = 'primary', children, ...props }) => {
  const [isPressed, setIsPressed] = useState(false);
  
  const ButtonComponent = {
    primary: PrimaryButton,
    destructive: DestructiveButton,
    outline: OutlineButton,
    transparent: TransparentButton,
    EbookToolingButton: EbookToolingButton
  }[variant] || PrimaryButton;

  const handleMouseDown = () => {
    setIsPressed(true);
  };

  const handleMouseUp = () => {
    setIsPressed(false);
  };

  return (
    <ButtonComponent
      className={isPressed ? 'scale-down' : 'scale-up'}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      {...props}
    >
      {children}
    </ButtonComponent>
  );
};

export default CustomButton;